// extracted by mini-css-extract-plugin
export default {"root":"EnUhkL","isPending":"dS8OW8"};